module.exports = __webpack_public_path__ + "static/media/3i_website_logo_coorg_hkstp.9cce6fc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/3i_website_logo_coorg_hkstp.jpg
// module id = 49
// module chunks = 0